import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import OrangeDownArrowIcon from 'shared/statics/svg/orange-arrow-down.svg?react';
import IndicatorHeader from '../ImpactIndicator/IndicatorHeader';
import { indicatorStageList } from '../ImpactIndicator/utils';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledDiv = styled.div`
  text-align: center;
  margin-top: 66px;
  .heading-container {
    margin-bottom: ${SPACERS.large};
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      max-width: 331px;
      text-align: center;
      margin-left: 19px;
      margin-right: 19px;
    }
    .flip {
      transform: scaleX(-1);
    }
  }
`;

const StaticIndicatorSections: React.FC = () => {
  return (
    <StyledDiv>
      <div className="heading-container">
        <OrangeDownArrowIcon />
        <TrueImpactText className="text">
          You’ll see your Impact Model come to life here as you complete this
          section.
        </TrueImpactText>
        <OrangeDownArrowIcon className="flip" />
      </div>
      <IndicatorHeader list={indicatorStageList} />
    </StyledDiv>
  );
};

export default StaticIndicatorSections;
